import { branch, renderNothing } from 'recompose';
import { complement } from 'ramda';

/**
 * A HOC that takes a function that determines whether a component should
 * render or not. This function will recieve props in order to use to determine
 * this. If it should render the component will render otherwise it will render
 * nothing.
 *
 * @example
 *
 * // Given a component with the props { firstName: 'Gus' }
 *
 * const isGus = propEq('firstName', 'Gus')
 *
 * renderIf(isGus)
 *
 * @param {object} shouldRender - A function determining whether to render or not.
 * @returns {object} - A HOC component with the component or render nothing function.
 */
export const renderIf = (shouldRender) =>
  branch(complement(shouldRender), renderNothing);
